import * as React from 'react'

export const Footer: React.FC = () => {
  return (
    <footer className="border-t bg-muted/50">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <div className="text-sm text-muted-foreground">
            <p>
              Powered by{' '}
              <a 
                href="https://www.warcraftlogs.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-medium hover:underline"
              >
                WarcraftLogs
              </a>
              {' '}• Not affiliated with Blizzard Entertainment
            </p>
          </div>
          
          <div className="flex items-center space-x-4 text-sm text-muted-foreground">
            <a 
              href="/privacy" 
              className="hover:underline"
            >
              Privacy
            </a>
            <a 
              href="/terms" 
              className="hover:underline"
            >
              Terms
            </a>
            <span>
              © 2024 WarcraftLogs Analyzer
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}